const { graphColors } = require('../../styles/colors')

const colors = Object.values(graphColors)

const knownColorCodings = {}

const setTruckColors = trucks => {
  trucks.forEach((truck, i) => {
    knownColorCodings[truck] = colors[i]
  })
}

const getTruckColor = truck => {
  return knownColorCodings[truck]
}

export default { setTruckColors, getTruckColor }
